module.exports = __webpack_public_path__ + "images/icon/edit_16_on-282d2ee1.svg";